import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import dictionary from '../../../Mobx/Dictionary';
import {
    Box,
    TextField,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Select,
} from '@mui/material';
import './SearchForm.css';

const SearchForm = observer(() => {
    const search = dictionary.search;
    const additionalInfoFields = search.additionalInfoFields;

    const [text, setText] = useState(search.text);
    const [field, setField] = useState(search.field);
    const [includes, setIncludes] = useState(search.includes);
    const [debouncedText, setDebouncedText] = useState(text);

    const fields = dictionary.current.fields;

    useEffect(() => {
        const handler = setTimeout(() => {
            dictionary.setCurrent(null, { text: debouncedText, field, includes, additionalInfoFields: dictionary.search.additionalInfoFields });
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [debouncedText, field, includes]);

    const handleTextChange = (e) => {
        handleInputChange(e); // קריאה לפונקציה שמקבעת כיוון טקסט
        setText(e.target.value);
        setDebouncedText(e.target.value);
    };

    const handleFieldChange = (e) => {
        setField(e.target.value);
        dictionary.setCurrent(null, { text: debouncedText, field: e.target.value, includes, additionalInfoFields });
    };

    const handleIncludesChange = (e) => {
        setIncludes(e.target.value);
        dictionary.setCurrent(null, { text: debouncedText, field, includes: e.target.value, additionalInfoFields });
    };

    const handleReset = () => {
        setText('');
        setField('original');
        setIncludes(false);
        setDebouncedText('');
        dictionary.setCurrent(null, { text: '', field: 'all', includes, additionalInfoFields: [] });
        setDirection('ltr'); // כיוון טקסט ברירת מחדל
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') handleReset();
    };

    // _________________________________________________________
    // פונקציה שמקבעת כיוון טקסט
    const [direction, setDirection] = useState(
        search.text ? /[\u0590-\u05FF]/.test(search.text.trim()[0]) ? 'ltr' : 'rtl' : 'ltr'
    ); // ברירת מחדל

    const handleInputChange = (event) => {
        const value = event.target.value;
        if (value) {
            // קביעת כיוון אוטומטית לפי התו הראשון
            const firstChar = value.trim()[0];
            setDirection(/[\u0590-\u05FF]/.test(firstChar) ? 'ltr' : 'rtl');
        } else {
            setDirection('ltr'); // ברירת מחדל כשהשדה ריק
        }
    };
    // _________________________________________________________
    return (
        <Box
            component="div"
            onKeyDown={handleKeyDown}
            className="search-form-container"
        >
            <FormControl className="search-form-select" sx={{ minWidth: '150px' }}>
                <InputLabel id="searchField-label"></InputLabel>
                <Select
                    id="searchField"
                    labelId="searchField-label"
                    value={field}
                    onChange={handleFieldChange}
                    sx={{ height: '34px' }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                textAlign: 'right', // מיישר את כל הטקסט לשמאל
                                direction: 'rtl', // מבטיח כיוון משמאל לימין
                            },
                        },
                    }}
                >
                    <MenuItem value="all">בכל השדות</MenuItem>
                    {fields.map((fieldOption) =>
                        fieldOption === '_id' ? null : (
                            <MenuItem key={fieldOption} value={fieldOption}>
                                {fieldOption}
                            </MenuItem>
                        )
                    )}
                </Select>
            </FormControl>

            <FormControl className="search-form-select" sx={{ minWidth: '110px' }}>
                <InputLabel id="includes-label"></InputLabel>
                <Select
                    id="includes"
                    labelId="includes-label"
                    value={includes}
                    onChange={handleIncludesChange}
                    sx={{ height: '34px' }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                textAlign: 'left',
                                direction: 'ltr',
                            },
                        },
                    }}
                >
                    <MenuItem value={false}>מתחיל עם</MenuItem>
                    <MenuItem value={true}>מכיל</MenuItem>
                </Select>
            </FormControl>

            <TextField
                id="searchText"
                // label="חפש במילון"
                sx={{
                    '& input': {
                        direction: direction, // כיוון דינמי
                    },
                }}
                variant="outlined"
                value={text}
                onChange={handleTextChange}
                placeholder="חפש במילון"
                autoComplete="off"
                className="search-text-field"
            />

            <Button
                variant="outlined"
                onClick={handleReset}
                className="search-form-button"
                sx={{
                    fontSize: '13px',
                    px: 2,
                    py: 0.5,
                    borderRadius: '4px', // מרובע
                    textTransform: 'none',
                    color: '#ffffff',
                    borderColor: '#ffffff',
                    backgroundColor: 'transparent',
                    height: '34px',
                    transition: '0.3s',
                    '&:hover': {
                        backgroundColor: '#ffffff',
                        color: '#1976d2', // כחול כהה להתאמה
                        borderColor: '#ffffff',
                    },
                }}
            >
                נקה
            </Button>
        </Box>
    );
});

export default SearchForm;
